import {
  currencyString,
  formatDate,
  isDefined,
  isFullPayoffPayment,
  isInstallmentBeforeScheduledDate,
  isLocOnOrBeforeScheduledDate,
  UseMessageT,
} from '@consumer-frontend/nc-utils';

export const useMessagePartialPayment: UseMessageT = (props) => {
  const {
    fullPayoffAmount,
    isFullPayoffDisabled,
    isAutopay,
    isAutopayPending,
    isNextMinimumPaymentDisabled,
    loanStatus,
    isMultiple,
    paymentAmount,
    paymentDate,
    productType,
    scheduledAmount,
    scheduledDate,
  } = props;

  if (!isDefined(fullPayoffAmount)
    || !isDefined(isFullPayoffDisabled)
    || !isDefined(paymentAmount)
    || !isDefined(paymentDate)
    || !isDefined(productType)
    || !isDefined(scheduledAmount)
    || !isDefined(scheduledDate)
  ) { return undefined; }

  const fullPayoffProps = {
    fullPayoffAmount,
    isFullPayoffDisabled,
    paymentAmount,
  };

  const logicHelperProps = {
    paymentDate,
    productType,
    scheduledDate,
  };

  // NCFE-10081 (C-1)
  if (isAutopay
    && !isAutopayPending
    && loanStatus === 'current'
    && paymentAmount < scheduledAmount
    && (isInstallmentBeforeScheduledDate(logicHelperProps) || isLocOnOrBeforeScheduledDate(logicHelperProps))
    && !isFullPayoffPayment(fullPayoffProps)
    && !isNextMinimumPaymentDisabled
  ) {
    return (
      <>
        <p>
          This payment will apply{' '}
          <span className="fw-bold">
            toward your AutoPay {isMultiple ? 'payments' : 'payment'}
          </span>{' '}
          {isMultiple ? 'totaling ' : 'of '}
          {currencyString(scheduledAmount)} scheduled for {formatDate(scheduledDate)}.
        </p>
        <p>
          The remaining{' '}
          <span className="fw-bold">
            {currencyString(scheduledAmount - paymentAmount)} will be automatically debited
          </span>{' '}
          on {formatDate(scheduledDate)}.
        </p>
      </>
    );
  }

  return undefined;
};
